<template>
  <section>
    <div>
      <form class="lm-forms">
        <div class="columns">
          <div class="column is-6 local-lm-filters">
            <b-field class="lm-label" :label="$t('NewSupplier.labelName')">
              <b-input
                class="local-lm-filters--input"
                v-model.trim="$v.name.$model"
                id="name"
              />
            </b-field>
            <b-field class="lm-label" :label="$t('NewSupplier.labelSurname')">
              <b-input
                class="local-lm-filters--input"
                v-model.trim="$v.surname.$model"
                id="surname"
              />
            </b-field>
            <b-field
              class="lm-label"
              :label="$t('NewSupplier.labelEmail')"
              :type="validateTypeEmail"
              :message="errorMessageEmail"
            >
              <b-input
                type="email"
                class="local-lm-filters--input"
                v-model.trim="$v.email.$model"
                id="email"
              />
            </b-field>
            <div class="buttons lr-rd-space-mTop">
              <b-button
                v-t="'Common.register'"
                type="is-success"
                class="button lr-width-50 lr-btn lr-txt-up"
                :disabled="disabled"
                @click.prevent="submitData"
                id="submit"
              />
            </div>
          </div>
          <div class="column is-6 local-lm-filters">
            <b-field
              class="local-lm-taginput-align"
              :label="$t('NewSupplier.labelPerfil')"
            >
              <b-dropdown
                aria-role="list"
                v-model.trim="selectedProfile"
                class="local-lm-filters"
                :triggers="['hover']"
              >
                <button
                  class="button"
                  type="button"
                  slot="trigger"
                  id="select-profile"
                >
                  <div class="local-lm-filters--placeholder">
                    <template>
                      <span
                        v-if="!selectedProfile"
                        v-t="$t('NewSupplier.profilePlaceholder')"
                      />
                      <span
                        v-else
                        v-t="$t(`NewSupplier.${selectedProfile}`).toUpperCase()"
                      />
                    </template>
                    <b-icon icon="chevron-down" />
                  </div>
                </button>
                <b-dropdown-item
                  v-for="(_profile, key) in profiles"
                  :key="key"
                  :value="_profile.profile"
                  :id="`profile-${_profile.profile}`"
                  v-t="$t(`NewSupplier.${_profile.profile}`).toUpperCase()"
                />
              </b-dropdown>
            </b-field>
            <b-field class="lm-label" :label="$t('NewSupplier.labelSuppier')">
              <b-taginput
                v-model.trim="selectSupplier"
                class="local-lm-filters"
                :data="suppliers"
                field="translation"
                type="is-success"
                autocomplete
                :allow-new="allowNew"
                :open-on-focus="openOnFocus"
                icon="label"
                :placeholder="$t('NewSupplier.supplierPlaceholder')"
                @typing="setSupplierFilter"
                @add="unsetSupplierFilter"
              />
            </b-field>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { mixin } from '@/mixins'

export default {
  name: 'NewSupplier',
  mixins: [mixin.notifications],
  computed: {
    ...mapGetters('supplier', ['activeSuppliers']),
    validateTypeEmail () {
      return !this.$v.email.email ? 'is-danger' : null
    },
    errorMessageEmail () {
      return !this.$v.email.email ? this.$t('Errors.validEmail') : null
    },
    suppliers () {
      return this.activeSuppliers
        .map(s => ({ key: s, translation: this.getSupplierLabel(s) }))
        .filter(s => s.translation.toLowerCase().includes(this.supplierFilter.toLowerCase()))
    }
  },
  data () {
    return {
      name: '',
      surname: '',
      email: '',
      selectedProfile: '',
      selectSupplier: null,
      openOnFocus: true,
      disabled: false,
      profiles: [],
      allowNew: false,
      supplierFilter: ''
    }
  },
  mounted () {
    this.getUserProfiles()
    this.getSuppliers()
  },
  methods: {
    async submitData () {
      this.$v.$touch()

      if (
        this.$v.name.$invalid ||
        this.$v.surname.$invalid ||
        this.$v.email.$invalid ||
        !this.selectedProfile ||
        !this.selectSupplier
      ) {
        return this.wrong(this.$t('Errors.warningAllFieldsWithData'))
      }

      const supplierIDs = this.selectSupplier.map(s => s.key.supplierID)

      const payload = {
        authorities: [ this.selectedProfile ],
        email: this.email,
        login: this.email,
        firstName: this.name,
        lastName: this.surname,
        supplierIDs
      }

      const createUser = await this.$store.dispatch('user/create', payload)
      if (!createUser.level) return this.wrong(this.$t(createUser.errorText))

      this.sucess(this.$t('Common.success'))
      this.name = ''
      this.surname = ''
      this.email = ''
      this.selectedProfile = ''
      this.selectSupplier = null
    },
    async getUserProfiles () {
      const profiles = await this.$store.dispatch('user/getProfiles')
      if (!profiles.level) return this.wrong(this.$t(profiles.errorText))

      this.profiles = profiles.data.map((profile, key) => {
        return {
          key,
          profile
        }
      })
    },
    async getSuppliers () {
      const suppliers = await this.$store.dispatch('supplier/getAllActiveSuppliers')
      if (!suppliers.level) return this.wrong(this.$t(suppliers.errorText))
    },
    getSupplierLabel (supplier) {
      return `${supplier.supplierID} -  ${supplier.supplierName.toUpperCase()}`
    },
    setSupplierFilter (text) {
      this.supplierFilter = text
    },
    unsetSupplierFilter () {
      this.supplierFilter = ''
    }
  },
  validations: {
    name: { required },
    surname: { required },
    email: {
      required,
      email,
      minLength: minLength(8)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/NewSupplier.vue